// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"styles_loaderContainer__1nMIK","errorContainer":"styles_errorContainer__bUIl2","doctorScreen":"styles_doctorScreen__3qIM1","container":"styles_container__2Q5-b"};